import { Path } from "utils/constants/paths.constants";

const getHAQPath = (projectId: string | undefined, HAQId: string | undefined) =>
  Path.ProjectHAQ.replace(":projectId", projectId ?? "").replace(
    ":HAQId",
    HAQId ?? "",
  );

export default getHAQPath;
